<mat-card class="cardWithShadow">
    <mat-card-header class="p-b-24 rounded" style="background: #1255ab;">
        <mat-card-title class="text-white">Incentivi GSE</mat-card-title>
    </mat-card-header>
    <mat-card-content class="p-24">
        <!-- <div class="d-sm-flex align-items-center f-s-25">
            Titolo di prima
            <div class="d-flex align-items-center gap-30 m-l-auto">
                <div class="d-flex gap-12">
                    <i-tabler name="circle-filled" class="text-accent icon-12 d-flex"></i-tabler>
                    <span class="mat-subtitle-2 text-accent">Budget</span>
                </div>
                <div class="d-flex gap-12">
                    <i-tabler name="circle-filled" class="text-primary icon-12 d-flex"></i-tabler>
                    <span class="mat-subtitle-2 text-primary">Expence</span>
                </div>
            </div>
        </div> -->

        <div class="row">
            <div class="col-lg-4" style="padding-top: 57px;">
                <div class="text-center">
                    <h6 class="mat-subtitle-1 f-w-500 f-s-24">&euro; 15.532,00</h6>
                    <span class="f-s-18">Totali</span>
                </div>

                <div class="d-flex m-t-24">
                    <div class="">
                        <h6 class="mat-subtitle-1 f-w-500 f-s-18">&euro; 14.427,00</h6>
                        <span class="f-w-500 f-s-14 d-block">Già
                            incassati</span>
                    </div>
                    <div style="flex: 1;padding: 0px 21px; text-align: right;">
                        <button (click)="linkRedirect('/incentive/payments')" mat-flat-button class="m-t-4 text-white"
                            style="width: 100px; background: #1e88e5;">
                            Dettagli
                        </button>
                    </div>
                </div>

                <div class="d-flex m-t-24">
                    <div>
                        <h6 class="mat-subtitle-1 f-w-500 f-s-18">&euro; 925,00</h6>
                        <span class="f-w-500 f-s-14 d-block">Da
                            incassare</span>
                    </div>
                    <div style="flex: 1;padding: 0px 21px; text-align: right;">
                        <button mat-flat-button (click)="linkRedirect('/incentive/calculate')" class="m-t-4 text-white"
                            style="width: 100px; background: #26c6da;">
                            Dettagli
                        </button>
                    </div>
                </div>

                <div class="m-t-20">
                    <!-- posto del grafico -->
                </div>
            </div>
            <div class="col-lg-8 text-center mx-auto">
                <div>
                    <apx-chart [series]="performanceChart.series" [plotOptions]="performanceChart.plotOptions"
                        [dataLabels]="performanceChart.dataLabels" [chart]="performanceChart.chart"
                        [legend]="performanceChart.legend" [colors]="performanceChart.colors"
                        [tooltip]="performanceChart.tooltip" [labels]="performanceChart.labels"
                        [stroke]="performanceChart.stroke">
                    </apx-chart>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>